import { render, staticRenderFns } from "./Payrunsapproved.vue?vue&type=template&id=21afe3b9"
import script from "./Payrunsapproved.vue?vue&type=script&lang=js"
export * from "./Payrunsapproved.vue?vue&type=script&lang=js"
import style0 from "./Payrunsapproved.vue?vue&type=style&index=0&id=21afe3b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports